import { Injectable, inject } from '@angular/core';

import { TASK_ACTION_HANDLERS, TaskActionHandler } from '../contracts/task-action.contract';
import { Task, TaskType } from '../models/task.interface';

@Injectable()
export class TaskActionHandlerRegistry {
  private readonly handlersByType = new Map<TaskType, TaskActionHandler>();

  constructor() {
    const handlers = inject(TASK_ACTION_HANDLERS, { optional: true }) ?? [];
    for (const handler of handlers) {
      this.handlersByType.set(handler.type, handler);
    }
  }

  get(type: TaskType): TaskActionHandler {
    const handler = this.handlersByType.get(type);
    if (!handler) {
      throw new Error(`No TaskActionHandler registered for task type: ${String(type)}`);
    }
    return handler;
  }

  execute(task: Task): void {
    this.get(task.type).execute(task);
  }
}
